import React, { Component, ErrorInfo, ReactNode } from 'react';
import { appInsights } from './app-insights';

interface ErrorBoundaryProps {
    children: ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Error caught by ErrorBoundary:', error, errorInfo);

        appInsights.trackException({
            exception: error,
            properties: { componentStack: errorInfo.componentStack },
        });
    }

    render() {
        if (this.state.hasError) {
            return <h2>Something went wrong. Please refresh the page.</h2>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
